import { DefaultTemplates } from "./templates";

export interface KTDatepickerConfigInterface {
	locale?: string;
	locales?: Partial<LocaleConfigInterface>;
	templates?: Partial<typeof DefaultTemplates>;

	weekDays: 'short' | 'long' | 'min';
	forceLeadingZero: boolean;
	minDate?: Date | string;
	maxDate?: Date | string;

	visibleMonths?: number;
	visibleYears?: number;

	dateFormat?: string;

	timeFormat?: string;
	enableTime?: boolean;
	am?: string;
	pm?: string;
	hourStep?: number;
	minuteStep?: number;
	secondStep?: number;
	disabledHours?: number[];
	disabledMinutes?: number[];

	range?: boolean;
	rangeSeparator?: string;

	// Element selectors
	inputSelector?: string;
	startInputSelector?: string;
	endInputSelector?: string;
	segmentSelector?: string;
	monthContainerSelector?: string;
	monthDisplaySelector?: string;
	yearDisplaySelector?: string;
	daysOfWeekSelector?: string;
	calendarGridSelector?: string;
	prevBtnSelector?: string;
	nextBtnSelector?: string;
	monthYearDisplaySelector?: string;
	dateCellSelector?: string;
	monthYearSelector?: string;
	monthOptionSelector?: string;
	yearOptionSelector?: string;
	timeInputSelector?: string;
	monthOptionsSelector?: string;
	yearOptionsSelector?: string;

	// Events
	initEvent?: string;
	dateChangeEvent?: string;
	keyboardNavigateEvent?: string;
	calendarRenderedEvent?: string;
	calendarPreviousMonthEvent?: string;
	calendarNextMonthEvent?: string;
	dropdownSelector?: string;
	mainDisplaySelector?: string;

	// Classes
	selectedClass?: string;
	hoveredInRangeClass?: string;
    dropdownActiveClass?: string;

	containerClass?: string;
	monthContainerClass?: string;
	daysOfWeekClass?: string;
	dayCellClass?: string;
	dayCellSelectedClass?: string;
	dayCellCurrentClass?: string;
	dayCellDisabledClass?: string;
	dayCellInRangeClass?: string;
	dayCellStartClass?: string;
	dayCellEndClass?: string;
	monthYearSelectorContainerClass?: string;
	monthYearDisplayClass?: string;
	monthYearDisplayTextClass?: string;
	monthYearOptionsContainerClass?: string;
	monthOptionClass?: string;
	monthOptionSelectedClass?: string;
	monthOptionCurrentClass?: string;
	yearOptionClass?: string;
	yearOptionSelectedClass?: string;
	yearOptionCurrentClass?: string;
	datetimeDisplayClass?: string;
	datetimeSegmentClass?: string;
	timeListContainerClass?: string;
	timeSelectorFlexContainerClass?: string;
	timePartContainerClass?: string;
	timePartLabelClass?: string;
	timeSelectClass?: string;
}

export interface LocaleConfigInterface {
	monthNames: string[];
	monthNamesShort: string[];
	dayNames: string[];
	dayNamesShort: string[];
	dayNamesMin: string[];
	firstDayOfWeek: number;
}

export interface DateRangeInterface {
	startDate: Date | null;
	endDate: Date | null;
}

export interface SelectedDateInterface {
	selectedDate?: Date;
	selectedDateRange?: DateRangeInterface;
}

export enum DatePickerSegment {
	Day = 'day',
	Month = 'month',
	Year = 'year',
	Hours = 'hours',
	Minutes = 'minutes',
	Seconds = 'seconds',
	AmPm = 'amPm',
	GmtOffset = 'gmtOffset',
	EndDay = 'endDay',
	EndMonth = 'endMonth',
	EndYear = 'endYear',
	EndHours = 'endHours',
	EndMinutes = 'endMinutes',
	EndSeconds = 'endSeconds',
	EndAmPm = 'endAmPm',
}

export interface DateTimeDisplayInterface {
	day: string;
	month: string;
	year: string;
	hours?: string;
	minutes?: string;
	seconds?: string;
	amPm?: string;
	gmtOffset?: string;
}

export enum ActiveInput {
	Start = 'start',
	End = 'end'
};